import { createElement, lazy } from 'react';

/**
 * React.lazy s možností stáhnout kód stránky předem.
 *
 * Při vstupu na podstránku by React místo HTML z prerenderu nejdřív vykreslil
 * náhradní spinner (Suspense) a teprve po stažení kódu obsah – návštěvník by
 * viděl blik a prohlížeč by počítal LCP až od druhého vykreslení. index.js
 * proto kód aktuální stránky stáhne před startem Reactu (HTML z prerenderu
 * je mezitím normálně vidět) a komponenta se pak vykreslí rovnou.
 */
export default function lazyWithPreload(factory) {
  let Loaded = null;
  let promise = null;
  const load = () => {
    if (!promise) {
      promise = factory().then((m) => { Loaded = m.default; return m; });
      // Neúspěšné stažení (výpadek, nové nasazení) zkusí React.lazy znovu
      promise.catch(() => { promise = null; });
    }
    return promise;
  };
  const Lazy = lazy(load);
  const Component = (props) => createElement(Loaded || Lazy, props);
  Component.preload = load;
  return Component;
}
